var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-winfow-wrapper",on:{"click":_vm.handleClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","position":"relative"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","display":"inline-block"},attrs:{"src":require("@/assets/image/floating-window-traning-icon.png"),"alt":""}})])
}]

export { render, staticRenderFns }